import { Button } from '../../school_panel/components/ui'
import { useState, useEffect } from 'react'
import AnswerPicker from './AnswerPicker'

interface IManualQuestionProps {
    onAdd: (q: any) => void;
}

const AddQuestionsManual = ({ onAdd }: IManualQuestionProps) => {
    const [question, setQuestion] = useState<string>('')
    const [choiceA, setChoiceA] = useState<string>('')
    const [choiceB, setChoiceB] = useState<string>('')
    const [choiceC, setChoiceC] = useState<string>('')
    const [choiceD, setChoiceD] = useState<string>('')
    const [answer, setAnswer] = useState<string>('A')

    const add = () => {
        const q = {
            question,
            choice_a: choiceA,
            choice_b: choiceB,
            choice_c: choiceC,
            choice_d: choiceD,
            ans: answer,
        }
        onAdd(q)
        setQuestion('')
        setChoiceA('')
        setChoiceB('')
        setChoiceC('')
        setChoiceD('')
        setAnswer('A')
    }

    const [EditorComp, setEditorComp] = useState<any>(null);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const mod = await import('quill-editor-math');
                if (!mounted) return;
                const Comp = (mod && (mod.default || mod));
                setEditorComp(() => Comp);
                try { await import('quill-editor-math/dist/index.css'); } catch (e) { }
            } catch (e) {
                // ignore
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <div>
            <h3 className='mb-1 font-display text-[15px] font-bold text-ink'>Add a question manually</h3>
            <p className='mb-4 text-[13px] text-muted'>Each question you add goes to the list for review before saving.</p>
            <div className='space-y-4'>
                <div>
                    <div className='mb-1.5 text-[13px] font-semibold text-ink'>Question</div>
                    {EditorComp ? <EditorComp initialValue={question} onChange={(v: any) => setQuestion(v)} /> : <div className='text-sm text-muted'>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-1.5 text-[13px] font-semibold text-ink'>Choice A</div>
                    {EditorComp ? <EditorComp initialValue={choiceA} onChange={(v: any) => setChoiceA(v)} /> : <div className='text-sm text-muted'>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-1.5 text-[13px] font-semibold text-ink'>Choice B</div>
                    {EditorComp ? <EditorComp initialValue={choiceB} onChange={(v: any) => setChoiceB(v)} /> : <div className='text-sm text-muted'>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-1.5 text-[13px] font-semibold text-ink'>Choice C</div>
                    {EditorComp ? <EditorComp initialValue={choiceC} onChange={(v: any) => setChoiceC(v)} /> : <div className='text-sm text-muted'>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-1.5 text-[13px] font-semibold text-ink'>Choice D</div>
                    {EditorComp ? <EditorComp initialValue={choiceD} onChange={(v: any) => setChoiceD(v)} /> : <div className='text-sm text-muted'>Loading editor…</div>}
                </div>

                <div className='flex flex-wrap items-center gap-3'>
                    <span className='text-[13px] font-semibold text-ink'>Correct answer</span>
                    <AnswerPicker value={answer} onChange={setAnswer} />
                </div>

                <div className='flex justify-end border-t border-hairline pt-4'>
                    <Button variant="secondary" onClick={add}>Add to list</Button>
                </div>
            </div>
        </div>
    )
}

export default AddQuestionsManual
